<form class="mt-3" role="form" novalidate name="form" #form="ngForm" method="post">



  <div class="row">
    <div class="col-12">
      <h1>Sync MatrixCare 360 Access Profile</h1>
      <div class="mb-2">
        <re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
      </div>

    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h3>Sync Details</h3>
    </div>
  </div>
  <div class="card bg-light">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <h3>Details</h3>
        </div>


        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="customer">Customer</label>

            <select2 required [settings]="{placeholder: 'Not Selected',width:'100%'}" id="customerId"
                     name="customerId"
                     [options]="customerOptions" [(ngModel)]="customerId"
                     (onSelect)="customerChanged($event)"></select2>

          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="environmentId">Environment</label>

            <select2 required [settings]="{placeholder: 'Not Selected',width:'100%'}" id="environmentId"
                     name="environmentId"
                     [options]="environmentOptions" [(ngModel)]="syncData.configId"
                     (onSelect)="environmentChanged($event)"></select2>

          </div>
        </div>



        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="corporation">Corporation</label>
            <select2 required [settings]="{placeholder: 'Not Selected',width:'100%'}" id="corporation" name="corporation"
                     [(ngModel)]="syncData.corpId" (onSelect)="corporationChanged($event)"
                     [options]="corporationOptions"></select2>

          </div>
        </div>



      </div>
    </div>
  </div>

  <div class="row mt-1">
    <div class="col-12">
      <button type="button" (click)="back()" class="btn btn-default">Back</button>
      <button type="submit" [disabled]="!form.valid || running" (click)="sync()" class="btn btn-primary">Sync Access Profile</button>
      <button type="button" *ngIf="isPhysicianFeatureEnabled" [disabled]="!form.valid || running" (click)="syncPhysicianNppa()" class="btn btn-primary ml-2">{{physicianNppaLabel}}</button>
      <span class="spinner spinner-sm ml-3" *ngIf="running">
        <span class="lspinner"></span>
      </span>



    </div>
  </div>
</form>
